import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import CometChatModal from 'components/base/Modal/CometChatModal'
import type { RootState } from 'redux/types'

const MODAL_ID = 'aiFeatures'

/**
 * Shown when an AI feature is toggled while AI Settings are not configured — the toggle cannot
 * save until an OpenAI key exists, so the user is sent to Settings instead.
 *
 * Rendered by `layouts/Main` and driven by `settings.visibleModalID`.
 */
const ModalAIFeatures: React.FC = () => {
  const settings = useSelector((state: RootState) => state.settings)
  const apps = useSelector((state: RootState) => state.apps)
  const dispatch = useDispatch()
  const history = useHistory()

  const { visibleModalID, featureLabel = '' } = settings as {
    visibleModalID?: string
    featureLabel?: string
  }

  const close = () =>
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: { setting: 'visibleModalID', value: '' },
    })

  const handleConfigure = () => {
    close()
    // Pre-select the Settings entry so the sidebar matches where we are navigating.
    localStorage.setItem('ccNavOpenKeys', JSON.stringify(['chats']))
    localStorage.setItem('ccNavSelectedKey', JSON.stringify(['chat-settings']))
    history.push(`/app/${apps.active?.id}/chat-settings`)
  }

  return (
    <CometChatModal
      open={visibleModalID === MODAL_ID}
      onCancel={close}
      onOk={handleConfigure}
      title="AI Feature Requires AI Settings to Be Enabled"
      description={`The ${featureLabel} feature cannot be enabled until AI Settings are enabled. Please enable AI Settings first, then return to activate this feature.`}
      okText="Configure AI Settings"
      hideCancel
      featuredIconName="alert-circle"
      maskClosable={false}
    />
  )
}

export default ModalAIFeatures
